import { get,post } from "../ajax";

export interface privItemType {
    userActivityId: string,
    refundAmount: number,
    remark: string
}
interface otherType {
   name:string 
}
export interface privListType extends otherType {
    userActivityId: string,
    refundAmount: number,
    remark: string
}

interface reissueType {
    userActivityId: number,
    activityId: number,
    activityCycleId: number,
    userActivityCycleId: number,
    productId: number,
    activityCycleProductId: number,
    collectionAccount: string | number,
}

export async function afterSalesList(body:Record<string, any>){
    const url = `/api/AfterSale/GetAfterSalePageList?Mobile=${body.Mobile}&OrderId=${body.OrderId}&CustomerOrderNo=${body.CustomerOrderNo}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function detailList(UserActivityId :number,ActivityId :number,Mobile :string){
    const url = `/api/AfterSale/GetAfterSaleDetailList?UserActivityId=${UserActivityId}&ActivityId=${ActivityId}&Mobile=${Mobile}`
    const res = await get(url)
    return res;
}

export async function activityCycleProduct(UserActivityCycleId :string,ActivityCycleId :string){
    const url = `/api/AfterSale/GetUserActivityCycleProduct?UserActivityCycleId=${UserActivityCycleId}&ActivityCycleId=${ActivityCycleId}`
    const res = await get(url)
    return res;
}

export async function cancelPriv(body:{
    datas:privItemType[]
}){
    const url = `/api/AfterSale/CancelUserActivity`
    const res = await post(url, body)
    return res;
}

export async function reissue(body:reissueType){
    const url = `/api/AfterSale/ReissueUserActivityCycleProduct`
    const res = await post(url, body)
    return res;
}

export async function recharge(body:{
    userRecordId:number,collectionAccount:string
}){
    const url = `/api/AfterSale/RechargeUserActivity`
    const res = await post(url, {userRecordId:body.userRecordId,collectionAccount:body.collectionAccount})
    return res;
}